import React from 'react';

import { AlertBody, AlertHeader, HomepageAlertContainer, LinkItem, Section } from './styled';

interface IAlert {
  headline: string;
  body: string;
  learnMore: string;
  learnMoreUrl: string;
}

const Alert: React.FC<React.PropsWithChildren<IAlert>> = ({
  headline,
  body,
  learnMore,
  learnMoreUrl,
}) => (
  <Section>
    <HomepageAlertContainer>
      <AlertHeader>{headline}</AlertHeader>
      <AlertBody>{body}</AlertBody>
      <LinkItem to={learnMoreUrl} isUnderlined>
        {learnMore}
      </LinkItem>
    </HomepageAlertContainer>
  </Section>
);

export default Alert;
